export default "__VITE_ASSET__DVeVMQyd__"